<template>
  <Dialog v-model="showDialog" v-if="showDialog" :transitionName="''" :closeOnClickModal="true" :showClose="false">
    <div class="poster-wrapper" :style="{ backgroundImage: shareBgColor }">
      <div class="poster-bg">
        <p class="poster-title">我的留言卡片</p>
        <swiper class="swiper-no-swiping" :options="swiperOption" v-if="list.length > 0">
          <swiper-slide class="swiper-slide" v-for="(item, index) in list" :key="index">
            <img :src="item" />
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
        <PosterCardImg id="one" :numbers="firstImg" />
        <PosterCardImg id="two" :numbers="secondImg" />
        <PosterCardImg id="three" :numbers="threeImg" />
        <div class="back-btn">
          <button class="btn" type="button" @click="goBack"><img src="@/assets/images/icon_back.png" alt="" /> 返回</button>
          <div class="long-tagtext"><img src="@/assets/images/icon_up.png" alt="" /><span class="text">右键图片保存到电脑</span></div>
        </div>
        <div class="poster-bottom"><img src="@/assets/images/icon_nfplus.png" alt="" /></div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "../Dialog"
import PosterCardImg from "./PosterCardImg/index"
import { mapGetters, mapActions } from "vuex"
import html2canvas from "html2canvas"
import { loadImgArr } from "@/utils/helpers/loadImg"
const POSTER_IMG = require("@/assets/images/poster2.png")
export default {
  name: "uiChooseCityDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var rotate = 0,
      stretch = -100,
      depth = 100,
      modifier = 1
    return {
      swiperOption: {
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: false,
        loop: false,
        slidesPerView: "auto",
        effect: "coverflow",
        centeredSlides: true,
        coverflowEffect: {
          rotate, //slide做3d旋转时Y轴的旋转角度。
          stretch,
          depth,
          modifier,
          slideShadows: false //开启slide阴影。
        }
      },
      list: []
    }
  },
  created() {
    this.getMyMessageList()
  },
  methods: {
    ...mapActions({
      getMyMessageList: "activityInfo/getMyMessageList"
    }),
    goBack() {
      this.showDialog = false
    },
    saveImg() {
      const posterList = this.myMessageList.slice(0, 3)
      const domId = ["#one", "#two", "#three"]
      let arr = posterList.map((item, index) => {
        return this.htmlCanvas(domId[index])
      })
      Promise.all(arr).then(res => {
        this.list = res
      })
    },
    htmlCanvas(id) {
      return new Promise(resolve => {
        let dom = document.querySelector(id)
        html2canvas(dom, {
          useCORS: true,
          x: -9999,
          y: 0,
          scrollX: 0,
          scrollY: 0,
          scale: 1,
          dpi: window.devicePixelRatio * 1,
          width: dom.offsetWidth,
          height: dom.offsetHeight
        }).then(canvas => {
          resolve(canvas.toDataURL("image/png"))
        })
      })
    }
  },
  components: {
    Dialog,
    PosterCardImg
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    },
    ...mapGetters({
      shareBgColor: "activityInfo/shareBgColor",
      userInfo: "userInfo/userInfo",
      myMessageList: "activityInfo/myMessageList",
      posterImage: "activityInfo/posterImage",
      fontColor: "activityInfo/fontColor"
    }),
    firstImg() {
      let temp
      if (this.myMessageList && this.myMessageList[0]) {
        temp = this.myMessageList[0]
      } else {
        temp = {}
      }
      return temp
    },
    secondImg() {
      let temp
      if (this.myMessageList && this.myMessageList[1]) {
        temp = this.myMessageList[1]
      } else {
        temp = {}
      }
      return temp
    },
    threeImg() {
      let temp
      if (this.myMessageList && this.myMessageList[2]) {
        temp = this.myMessageList[2]
      } else {
        temp = {}
      }
      return temp
    },
    cardDescColor() {
      function hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            }
          : {}
      }
      const { r, g, b } = hexToRgb(this.fontColor)
      return `rgba(${r}, ${g}, ${b}, 0.5)`
    }
  },
  watch: {
    value(newvalue) {
      if (newvalue) {
        this.$nextTick(() => {
          this.getMyMessageList()
          const imgArr = [this.userInfo.userAvatarImg, POSTER_IMG, this.posterImage]
          loadImgArr(imgArr).then(() => {
            this.saveImg()
          })
        })
      }
    }
  },
  mounted() {
    // setTimeout(() => {
    //   const imgArr = [this.userInfo.userAvatarImg, POSTER_IMG]
    //   loadImgArr(imgArr).then(() => {
    //     this.saveImg()
    //   })
    //   window.console.log(this.list, "this.firstImg, this.secondImg, this.threeImg")
    // }, 1000)
  }
}
</script>
<style lang="scss" scoped>
.poster-wrapper {
  width: 750px;
  height: 700px;
  border-radius: 20px;
  .poster-bg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .poster-title {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      letter-spacing: 0;
      text-align: center;
      margin-top: 30px;
    }
  }
  .swiper-container {
    width: 100%;
    margin-top: 30px;
    .swiper-slide {
      width: 325px;
      height: 420px;
      // overflow: hidden;
      position: relative;
      img {
        width: 375px;
        height: 572.5px;
        position: absolute;
        left: -25px;
        top: -62px;
        z-index: 1;
      }
    }
  }
  .swiper-button-prev {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border-color: none !important;
    overflow: hidden;
    background: url("../../assets/images/icon_previous.png") no-repeat;
    left: 65px;
    background-size: cover;
    color: #fff;
    outline: none;
    &:active {
      opacity: 0.7;
      border-color: none !important;
    }
    &::after {
      display: none;
    }
  }
  .swiper-button-next {
    width: 64px;
    height: 64px;
    border-color: none !important;
    overflow: hidden;
    border-radius: 50%;
    background: url("../../assets/images/icon_next.png") no-repeat;
    right: 65px;
    background-size: cover;
    color: #fff;
    outline: none;
    &:active {
      opacity: 0.7;
    }
    &:root {
      color: none !important;
    }
    &::after {
      display: none;
    }
  }
  .back-btn {
    width: 430px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 76px;
    .btn {
      background: #ffffff;
      font-size: 16px;
      border-radius: 30px;
      width: 80px;
      height: 40px;
      cursor: pointer;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #555555;
      > img {
        margin-right: 10px;
      }
    }
    .long-tagtext {
      width: 168px;
      font-family: PingFang-SC-Bold;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #ffffff;
    }
  }
  .poster-bottom {
    position: absolute;
    bottom: 10px;
    img {
      width: 119px;
      height: 37px;
    }
  }
  #one,
  #two,
  #three {
    position: fixed;
    z-index: -999;
    left: -9999px;
    top: 0;
  }
}
</style>
